import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStrokedCross = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M144 195L445 496L144 797L199 852L500 551L801 852L856 797L555 496L856 195L801 140L500 441L199 140Z" })
});
export default SvgStrokedCross;
